import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=3a9bbc38&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=ts&"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=3a9bbc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9bbc38",
  null
  
)

export default component.exports